import React from "react";
import Button from "../Button";
import { colors } from "../../styles";
import file from "../../assets/file.png";
import CONFIG from "../../CONFIG";

const TEXT = CONFIG.MAIN_PAGE.HERO;
const BUTTON_TEXT = CONFIG.GLOBAL.PRIMARY_BUTTON_TEXT;
const { accent } = colors;
const HeroBox = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "93vh",
  marginTop: "7vh",
};

const FileImage = {
  height: "25%",
  borderRadius: "50%",
  border: `1px solid ${accent}`,
  boxShadow: `5px 5px ${accent}`,
};

const PrimaryButton = {
  margin: "15px 0",
  fontSize: "1.5rem",
};

const TagLine = {
  maxWidth: 800,
  minWidth: 300,
  width: "80%",
};

const Hero = ({ share }) => {
  return (
    <div style={HeroBox}>
      <img src={file} style={FileImage} alt="File Share Now" />
      <h1>{TEXT.TAG_LINE}</h1>
      <div style={TagLine}>{TEXT.SUB_TAG}</div>
      <Button onClick={share} style={PrimaryButton}>
        {BUTTON_TEXT}
      </Button>
    </div>
  );
};

export default Hero;
